export const fwsed = {
  routes: [
    {
      path: "/fwsed/dashboard",
      component: () => import("../fwsed-dashboard"),
    },
  ],
};
